import { withErrorBoundary } from "app/ErrorBoundary/ErrorBoundaryDashboard";
import { OpLoggInput } from "features/TodoOploggSidebar/Oplogg/OploggInput";
import OploggMessages from "features/TodoOploggSidebar/Oplogg/OploggMessages";
import { Separator } from "shared/components/Spor";
import styled, { useTheme } from "styled-components";

const OploggWrapper = styled.div`
  display: grid;
  grid-template-areas: "input" "separator" "messages";
  grid-template-rows: auto auto 1fr;

  min-height: 0;
  height: 100%;

  background-color: ${({ theme }) => theme.colorBackgroundMain};
  border: 1px solid ${({ theme }) => theme.colorOutlineSecondary};
  border-radius: 6px;

  width: 100%;
  overflow-y: auto;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
  border-bottom: 1px solid ${({ theme }) => theme.colorOutlineSecondary};
`;

const Oplogg = () => {
  const theme = useTheme();
  return (
    <OploggWrapper>
      <OpLoggInput />
      <Separator borderTop={`1px solid ${theme.colorOutlineSecondary}`} />
      <OploggMessages />
    </OploggWrapper>
  );
};

export default withErrorBoundary(Oplogg);
